import {Box, Grid} from '@mui/material';
import {useTranslation} from 'react-i18next';
import DialogForm from '@/components/ui/dialogs/form-dialog';
import {useCallback, useState} from 'react';
import {useSnackbar} from '@/contexts/snackbar';
import CompanyAddForm from '@/components/forms/admin/companies/add';
import CompanyCard from './company-card';
import {useAppSelector} from '@/redux-store/store';
import ResponsiveFab from '@/components/ui/responsive-fab';
import SearchBar from '@/components/ui/search-bar';
import GoBackComponent from '@/components/ui/go-back-component';

const CompaniesPanel = () => {
  const {t} = useTranslation();

  const {showSnackbarMessage} = useSnackbar();

  const userRole = useAppSelector((state) => state.auth.keycloakUser?.userRole);

  const [showAddCompanyForm, setShowAddCompanyForm] = useState(false);
  const [searchText, setSearchText] = useState('');
  const adminCompanies = useAppSelector(
    (state) => state.adminCompanies.adminCompanies
  );
  const userCompany = useAppSelector((state) => state.company.company);
  const isAdmin = userRole && userRole === 'ADMIN';

  const handleSearchChange = useCallback((searchTerm: string) => {
    setSearchText(searchTerm);
  }, []);

  const handleAddCompanyClick = useCallback(() => {
    setShowAddCompanyForm(true);
  }, []);

  const handleAddCompanyCancel = useCallback(() => {
    setShowAddCompanyForm(false);
  }, []);

  const onCompanyAdded = useCallback(() => {
    setShowAddCompanyForm(false);
    showSnackbarMessage(t('company_add_success'), 'success');
  }, [showSnackbarMessage, t]);

  const onAddCompanyError = useCallback(() => {
    showSnackbarMessage(t('company_add_failure'), 'error');
  }, [showSnackbarMessage, t]);

  const filteredAdminCompanies =
    adminCompanies?.filter((company) => {
      return company.title.toLowerCase().includes(searchText.toLowerCase());
    }) || [];

  return (
    <Box marginTop={4}>
      <ResponsiveFab onClick={handleAddCompanyClick} title={t('add_company')} />
      <GoBackComponent />

      <Box marginTop={3} marginBottom={2}>
        <SearchBar
          onSearch={handleSearchChange}
          placeholder={t('company_search')}
        />
        <Grid container spacing={3} marginTop={2}>
          {isAdmin ? (
            filteredAdminCompanies.map((company, index) => (
              <CompanyCard key={index} company={company} />
            ))
          ) : (
            <CompanyCard key={userCompany._id} company={userCompany} />
          )}
        </Grid>
      </Box>
      <DialogForm
        open={showAddCompanyForm}
        onSubmit={onCompanyAdded}
        onCancel={handleAddCompanyCancel}
        onError={onAddCompanyError}
        FormComponent={CompanyAddForm}
        maxHeightAllowed={'no'}
      />
    </Box>
  );
};

export default CompaniesPanel;
